import { render, staticRenderFns } from "./InventoryReasonCodes.vue?vue&type=template&id=bd3f825a&scoped=true"
import script from "./InventoryReasonCodes.vue?vue&type=script&lang=js"
export * from "./InventoryReasonCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3f825a",
  null
  
)

export default component.exports